/**
 * Opens a print window with the provided content
 * @param content - The HTML content to print
 * @param title - The title for the print window
 * @param cssPath - Optional path to CSS file (defaults to print.css)
 */
export const openPrintWindow = (
  content: string,
  title: string,
  cssPath = '../../../print.css'
): void => {
  const winPrint = window.open(
    '',
    '',
    'left=0,top=0,width=384,height=900,toolbar=0,scrollbars=0,status=0'
  )
  
  if (!winPrint) {
    return
  }
  
  winPrint.document.write('<html><head>')
  winPrint.document.write(`<title>${title}</title>`)
  winPrint.document.write(`<link rel="stylesheet" href="${cssPath}">`)
  winPrint.document.write('</head><body>')
  winPrint.document.write(content)
  winPrint.document.write('</body></html>')
  
  setTimeout(() => {
    winPrint.print()
  }, 500)
  
  setTimeout(() => {
    winPrint.close()
  }, 700)
}